import {
  getFirstAccessibleChild,
  getFirstAccessibleRoute,
} from '@/features/auth/access-control/getFirstAccessibleChild';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/dashboard/')({
  beforeLoad: ({ context }) => {
    const first = getFirstAccessibleChild('/dashboard', context.perms) ?? getFirstAccessibleRoute(context.perms);
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: first,
      replace: true,
    });
  },
});
